export enum PaymentMethodCode {
    responsive = 'responsive',
    directDebit = 'directDebit' ,
    creditcard = 'creditcard',
    CommitmentToPayment = 'CommitmentToPayment',
    Ext_PaymentInKind = 'Ext_PaymentInKind',
    GrainExchange = 'GrainExchange'
}
